import React, { Component } from "react";

import DeleteIcon from "calcite-ui-icons-react/TrashIcon";
import EditIcon from "calcite-ui-icons-react/PencilIcon";
import SaveIcon from "calcite-ui-icons-react/SaveIcon";
import CancelIcon from "calcite-ui-icons-react/XCircleIcon";

import AddArea from "./AddArea";
import Button from "../../../common/components/Button";
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import { ModalController } from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import Rdx from "../../../redux/Rdx";
import TextField from "../../../common/components/TextField";
import Topic from "../../../context/Topic";
import TransactionGuard from "../../base/TransactionGuard";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";

import { HeaderContainer, Title, ButtonContainer } from '../../styles/Work/areaHeader';
import { queryPeopleAssignedToArea } from "../../base/officePlanUtil";
import { canDeleteDuplicate, deleteDuplicatePeople, getAttributes } from "../common/MultipleAssignments/multipleAssignmentsUtil";

class AreaHeader extends Component {

  useRdx = true;

  constructor(props) {
    super(props);
    this.state = component.newState({
      modifiedName: null,
      expanded: false,
      editOn: false
    });
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  deleteClicked = () => {
    const i18n = Context.instance.i18n;
    //const rdxActiveAreaKey = this.props.rdxActiveAreaKey;
    const options = {
      title: i18n.spaceplanner.areaProperties.delCaption,
      message: i18n.spaceplanner.areaProperties.delPrompt,
      okLabel: i18n.spaceplanner.areaProperties.del,
      closeOnOK: false,
      closeOnCancel: false,
    }
    ModalController.confirm(options).then(result => {
      if (result.ok) {
        result.controller.close();
        const guard = new TransactionGuard({force: true});
        const plan = Context.instance.spaceplanner.activePlan;
        const areasTable = plan && plan.areasTable;
        const areaItem = this.getAreaItem();
        const areaType = this.getAreaType()
        let duplicates = []
        queryPeopleAssignedToArea(areaItem, areaType).then(people => {
          const promises = []
          if (people && people.length > 0) {
            people.forEach(person => {
              const attributes = getAttributes(person)
              const personName = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_FULLNAME)
              const personEmail = aiimUtil.getAttributeValue(attributes, FieldNames.PEOPLE_EMAIL)
              const promise = canDeleteDuplicate(personName, personEmail).then(result => {
                if (result) duplicates.push(person)
              })
              promises.push(promise)
            })
          }
          return Promise.all(promises)
        }).then(() => {
          return areasTable.deleteArea(areaItem)
        }).then(() => {
          if (duplicates && duplicates.length > 0) {
            duplicates = duplicates.map(p => {return {person: p, associatedUnit: null, associatedArea: areaItem}})
            deleteDuplicatePeople(duplicates, true, false)
          }
        }).then(() => {
          guard.close();
          Topic.publish(Topic.PlanModified, {
            action: OfficePlan.Action_AssignmentsUpdated
          });
          const areaType = this.getAreaType();
          let rdxActiveAreaKey;
          if(areaType === "hotel") rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTEL_AREA_ID;
          else if(areaType === "hotdesk") rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTDESK_AREA_ID;
          Rdx.setValue(null, rdxActiveAreaKey, null);
          //result.controller.close();
        }).catch(error => {
          guard.close();
          //result.controller.close();
          console.error("Error updating area", error);
          Topic.publishErrorUpdatingData(error.submessage);
        });
      } else {
        result.controller.close();
      }
    });
  }

  editClicked = () => {
    const areaName=this.getAreaName();
    this.setState({ editOn: true, modifiedName: areaName });
  }

  editCancelClicked = () => {
    this.setState({ editOn: false, modifiedName:null });
  }

  getAreaId = () => {
    const areaItem = this.getAreaItem();
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
  }

  getAreaItem = () => {
    return this.props.areaItem;
  }

  getAreaName = () =>{
    const areaItem = this.getAreaItem();
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_NAME);
  }

  getAreaType = () => {
    return this.props.areaType;
  }

  getRdxActiveAreaKey = () => {
    return "area_id"
  }

  onChangeName = evt => {
    this.setState({ modifiedName: evt.target.value });
  }

  onKeyDownName = evt => {
    if (evt.key === "Enter") {
      this.saveClicked();
    }
  }

  render() {
    const i18n = Context.instance.i18n;
    const areaName=this.getAreaName();
    const modifiedName = this.state.modifiedName;
    const editOn = this.state.editOn;
    const { rdxActiveAreaId } = this.props;
    const tooLong = areaName.length >= 30
    let tooltip = tooLong ? areaName : ""
    const truncatedAreaName = tooLong ? areaName.substring(0, 30).trim() + "..." : areaName 

    return (
      <HeaderContainer>
        <Title>
          {
            editOn ? <TextField className={"i-areaheader-textfield"}
              value={modifiedName}
              onChange={this.onChangeName}
              onKeyDown={this.onKeyDownName} /> 
              : <div title={tooltip}>{truncatedAreaName}</div>
          }
        </Title>
        <ButtonContainer>
          {rdxActiveAreaId ?
            editOn ?
              (<>
              <Button key="clear" clear={true}
                title={i18n.general.cancel}
                onClick={this.editCancelClicked}
                iconButton={true} icon={<CancelIcon />} />
              <Button key="save" clear={true}
                title={i18n.spaceplanner.areaProperties.save}
                onClick={this.saveClicked}
                iconButton={true} icon={<SaveIcon />} />
                </>
              ) :
              (<><Button key="edit" clear={true}
                title={i18n.spaceplanner.areaProperties.edit}
                onClick={this.editClicked}
                iconButton={true} icon={<EditIcon />} />
                <Button key="delete" clear={true}
                  title={i18n.spaceplanner.areaProperties.del}
                  onClick={this.deleteClicked}
                  iconButton={true} icon={<DeleteIcon />} />
              </>)
            : null
          }
        </ButtonContainer>
      </HeaderContainer>
    );
  }

  saveClicked = () => {
    const areaItem = this.getAreaItem();
    const plan = Context.instance.spaceplanner.activePlan;
    const areasTable = plan && plan.areasTable;
    let areaName = this.state.modifiedName;
    const isInvalidName=AddArea.isInvalidPattern(areaName);
    const officePlan = OfficePlan.getActive()

    const i18n = Context.instance.i18n;
    const emptyInput = i18n.spaceplanner.areaProperties.emptyAreaName;
    const invalidInput = i18n.spaceplanner.areaProperties.invalidAreaName;

    let invalidAreaTitle;

    const areaType=this.getAreaType();
    if(areaType === "hotel") invalidAreaTitle=i18n.spaceplanner.areaProperties.invalidHotelTitle;
    else if(areaType === "hotdesk") invalidAreaTitle=i18n.spaceplanner.areaProperties.invalidHotdeskTitle;

    if(!areaName || areaName.trim().length === 0){
      ModalController.alert({
        title: invalidAreaTitle,
        message: emptyInput
      });
      return;
    }

    if(isInvalidName){
      ModalController.alert({
        title: invalidAreaTitle,
        message: invalidInput
      });
      return;
    }

    const confirmModal = (options) => {
      ModalController.confirm(options).then(result => {
        if (result.ok) {
          onOK();
        }
      })
    }

    const doesHotdeskAreaExist = () => {
      let isDuplicate = false;
      officePlan.queryHotDeskAreas().then(areas => {
        const result = areas;
        for (let i = 0; i < result.length; i++) {
          const name = aiimUtil.getAttributeValue(result[i].attributes,FieldNames.AREA_NAME);
          if (name === areaName) {
            isDuplicate = true;
            const options = {
              title: i18n.spaceplanner.areaProperties.duplicateHotdeskName,
              message: i18n.spaceplanner.areaProperties.duplicateHotdeskNamePrompt,
              okLabel: i18n.general.ok,
              closeOnOK: true,
              closeOnCancel: true
            };
            confirmModal(options);
            break;
          }
        }
      }).then(() => {
        if (isDuplicate === false) {
          onOK();
        }
      })
      .catch(ex => {
        console.warn("Error querying hotel areas:");
        console.error(ex);
        Topic.publishErrorAccessingData();
      });
    }

    const doesHotelNameExist = () => {
      let isDuplicate = false;
      officePlan.queryHotelAreas().then(areas => {
        const result = areas;
        for (let i = 0; i < result.length; i++) {
          const name = aiimUtil.getAttributeValue(result[i].attributes,FieldNames.AREA_NAME);
          if (name === areaName) {
            isDuplicate = true;
            const options = {
              title: i18n.spaceplanner.areaProperties.duplicateHotelName,
              message: i18n.spaceplanner.areaProperties.duplicateHotelNamePrompt,
              okLabel: i18n.general.ok,
              closeOnOK: true,
              closeOnCancel: true
            };
            confirmModal(options);
            break;
          }
        }
      }).then(() => {
        if (isDuplicate === false) {
          onOK();
        }
      })
      .catch(ex => {
        console.warn("Error querying hot desk areas:");
        console.error(ex);
        Topic.publishErrorAccessingData();
      });
    }

    const onOK = () => {
      if (typeof areaName === "string") areaName = areaName.trim();
      if (areaName.length > 0) {
        const guard = new TransactionGuard({force: true});
        areasTable.updateArea(areaItem, areaName).then(result => {
          guard.close();
          const f = aiimUtil.findField(areasTable.table.fields,FieldNames.AREA_NAME);
          areaItem.attributes[f.name]=areaName;
          Topic.publish(Topic.PlanModified, {
            action: OfficePlan.Action_AssignmentsUpdated
          });
          this.setState({ editOn: false });
        }).catch(error => {
          guard.close();
          console.error("Error updating area", error);
          Topic.publishErrorUpdatingData(error.submessage);
        });
      }
    }

    if (areaType === "hotel") {
      doesHotelNameExist();
    } else if (areaType === "hotdesk") {
      doesHotdeskAreaExist();
    }
  }

}

export default AreaHeader;
